import type { NetworkInfo } from "@alch/dx-entities";
import clsx from "clsx";
import React from "react";
import { Emblem } from "./emblem.js";
import { networkEmblemUrl } from "./helpers.js";

interface NetworkEmblemProps extends React.HTMLAttributes<HTMLDivElement> {
  networkInfo: Pick<NetworkInfo, "name" | "chainId" | "isTestNet">;
}

const BaseEmblem = (
  { networkInfo, ...props }: NetworkEmblemProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) => {
  const { name, chainId, isTestNet } = networkInfo;
  const imageUrl = networkEmblemUrl(chainId, isTestNet);

  return (
    <Emblem
      imageAlt={name}
      imageUrl={imageUrl}
      ref={ref}
      {...props}
      className={clsx("rounded-full bg-emblem", props.className)}
    />
  );
};

export default React.forwardRef(BaseEmblem);
